import { z } from 'zod';

import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';

import { zodPlaceholder, zodSelectOption } from '@/shared/lib/validations';

export const learningDocumentBaseSchema = z.object({
  learningDoc: zodSelectOption,
  learningDocument: zodPlaceholder,
});

export const learningDocumentSchema = learningDocumentBaseSchema.superRefine((data, ctx) => {
  if (Number(data.learningDoc.id)) {
    const learningDocumentResult = documentDataSchema.safeParse(data.learningDocument);

    if (!learningDocumentResult.success) {
      learningDocumentResult.error.issues.forEach((issue) => {
        ctx.addIssue({
          ...issue,
          path: ['learningDocument', ...issue.path],
        });
      });
    }
  }
});
